import React from 'react'
import Card from 'react-bootstrap/Card'

import { Link, NavLink } from 'react-router-dom'

import { useState } from 'react'

import { PALETTE } from '../ThemeConstants'

export default function CardOverlay({
  name="",
  header="" ,
  description="",
  color=PALETTE.LIGHTGRAY,
  backgroundColor=PALETTE.DARK,
  backgroundColorHover= PALETTE.DARK,
  cover="Undefined",
  close=true,
  width=200,
  height=200,
  duration,
  level,
  icon,
  to="",
  isActive=true,
  onClose= () => {},
  onClick= () => {},
  className,
}) {

  const [isCloseHover, setIsCloseHover] = useState()
  const [isCardHover, setIsCardHover] = useState()

  const toUrl = to // isActive? to : ""

  const closeStyle = {
    color: isCloseHover ? PALETTE.MAINCOLOR : PALETTE.WHITE,
    position:'absolute',
    marginLeft:width-50,
    cursor:'pointer'
  }

  // const cardBackgroundColor = isCardHover? backgroundColorHover : backgroundColor
  const cardBackgroundColor = backgroundColor

  return (
    <Card
      onMouseEnter={() => setIsCardHover(true)}
      onMouseLeave={() => setIsCardHover(false)}
      onClick={onClick}
      style={{
        height:height,
        width:width,
        color:color,
        background:cardBackgroundColor,
        boxShadow: !isActive && "none"
      }}
      className="text-center m-auto workout-card"
    >
      {icon && (
        <NavLink to={toUrl} className="text-centers align-self-center" style={{textDecoration: 'none', color:color}}>
            <div
              className="align-self-center"
              style={{
                position:"absolute",
                width:"100%",
                height:"100%",
                left:0,
                right:0,
                top:65,
                zIndex:500
              }}>
              {icon}
            </div>
        </NavLink>
        )}
      <Card.Img
        className="opacity-25"
        src={cover}
        alt={name}
        style={{
          height:height,
          width:width,
          objectFit: "cover"
        }}
      />
      <Card.ImgOverlay className="py-4">
        {close &&
        <>
          <div
          onMouseEnter={() => setIsCloseHover(true)}
          onMouseLeave={() => setIsCloseHover(false)}
          style={closeStyle}
          onClick={onClose}
          >
            <span className="text-right">X</span>
          </div>
          <br/>
        </>
        }
        {header !== "" && <p>{header}</p>}
        <Link to={toUrl} className="text-centers" style={{textDecoration: 'none', color:color}}>
          <p className="cardTitle">{name}</p>
          <p className="cardDescription">{description}</p>
          {level && <p className="cardDescription m-0">Level: {level}</p>}
          {duration && <p className="cardDescription m-0">Time: {duration}'</p>}
        </Link>
      </Card.ImgOverlay>
    </Card>
  )
}